import { getPlayerData } from "core-integration/src/store/player/reducers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Register from "../player/Register";
import CreateEntryDialog from "./CreateEntryDialog";
import { IListTableProps } from "./CreateSquad";
import SquadBase from "./SquadBase";
import SquadListTable from "./SquadListTable";

const SquadSelection = () => {
  const { t } = useTranslation();
  const player = useSelector(getPlayerData);
  if (!player || player.dirty) {
    return <Register />;
  }
  return (
    <SquadBase
      listTable={(listTableProps: IListTableProps) => (
        <SquadListTable {...listTableProps} />
      )}
      scoreboard="basic"
      submitDialog={(handleHide: () => void, allowNavigation: () => void) => (
        <CreateEntryDialog
          handleHide={handleHide}
          allowNavigation={allowNavigation}
        />
      )}
      title={t("squad.title", "Squad Selection")}
    />
  );
};

export default SquadSelection;
